import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_12W_66_65_12W_25_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_12w_66_65_12w_25_99_usd',
			AUD: 'simple_premium_12w_99_99_12w_39_99_aud',
			BRL: 'simple_premium_12w_379_12w_146_99_brl',
			CAD: 'simple_premium_12w_89_99_12w_35_99_cad',
			DKK: 'simple_premium_12w_439_12w_169_dkk',
			EUR: 'simple_premium_12w_66_65_12w_25_99_eur',
			GBP: 'simple_premium_12w_66_65_12w_25_99_gbp',
			MXN: 'simple_premium_12w_1279_12w_499_mxn',
			NOK: 'simple_premium_12w_669_12w_259_nok',
			SEK: 'simple_premium_12w_639_12w_249_sek',
			TRY: 'simple_premium_12w_2900_12w_999_try',
			ARS: 'simple_premium_12w_89190_12w_34690_ars',
			COP: 'simple_premium_12w_269990_12w_105490_cop',
			CLP: 'simple_premium_12w_64990_12w_25290_clp',
		},
		primer: 'prd_wlUgE7otqhKd',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 25.99,
			AUD: 39.99,
			BRL: 146.99,
			CAD: 35.99,
			DKK: 169,
			EUR: 25.99,
			GBP: 25.99,
			MXN: 499,
			NOK: 259,
			PLN: 96.99,
			SEK: 249,
			TRY: 999,
			ARS: 34690,
			COP: 105490,
			CLP: 25290,
		},
		originalPriceMap: {
			USD: 66.65,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
			ARS: 89190,
			COP: 269990,
			CLP: 64990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 66.65,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
			ARS: 89190,
			COP: 269990,
			CLP: 64990,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $tc('common.duration.week.first', 12), // first 12 weeks
		explicitTermsIntervalText: $tc('common.week_plural', 12), // 12 weeks
		billingSubtitlePeriodText: $tc('common.week_plural', 12), // '12 weeks'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 12), // '12-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 12), // '12-week'
	}),
}
